// -----------------  GET USER PAYMENTS -----------------
export const USER_PAYMENTS_LOADING = 'USER_PAYMENTS_LOADING';
export const USER_PAYMENTS_SUCCESS = 'USER_PAYMENTS_SUCCESS';
export const USER_PAYMENTS_ERROR = 'USER_PAYMENTS_ERROR';
